import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.StandaloneStartStep', {
    bubbleText: 'Creation',
    createInApprovalMax: 'Create in ApprovalMax',
    description: 'Add users who should be able to create requests and submit them for approval.',
});
